import {DataObject} from "@/services/data/dataObject";
import TimeStamp from "@/services/timeStamp";
import FirebaseWrite from "@/services/database/firebaseWrite";
import store from "@/store/store";

export class Kugel extends DataObject{
    constructor(dataObject, owner, ownerType, birthday) {
        super();
        this.id = null
        this.nr = ''
        this.ownerType = ownerType // spieler/verein
        this.ownerId = '' // spielerId, VereinsId
        this.ownerName = '' // Spielername, Vereinsname
        this.geburtsdatum = '' // optional nur Spieler
        this.sportart = '' // classic/bowling
        this.kommentar = ''
        this.gueltigBis = ''
        this.waitingForPassPrint = true
        this.tsLastPassPrint = 0
        this.tsCreated = 0
        this.tsLastUpdated = 0
        this.createdByName = ''
        this.lastUpdatedByName = ''
        if ( dataObject ) {
            this.setFromDataObject(dataObject)
        }
        if ( owner ) {
            this.setDataFromOwner(owner, birthday)
        }
    }

    setDataFromOwner(owner, birthday){
        if ( this.ownerType === 'spieler' ) {
            this.setDataFromSpieler(owner, birthday)
        } else {
            this.setDataFromVerein(owner)
        }
    }
        setDataFromSpieler(spieler, birthday){
            this.ownerId = spieler.id
            this.ownerName = spieler.vorname + ' ' + spieler.nachname
            this.geburtsdatum = birthday
            this.sportart = spieler.sportart
        }
        setDataFromVerein(verein){
            this.ownerId = verein.id
            this.ownerName = verein.name
            this.sportart = verein.id.substring(0,2)<'20' ? 'classic' : 'bowling'
        }

    async save(){
        const dbObject = this.getDBSaveObject()
        if ( this.id ) {
            let reply = await FirebaseWrite.update('kugeln', this.id, dbObject)
            reply.content = JSON.parse(JSON.stringify(dbObject))
            reply.content.id = this.id
            return reply
        } else {
            return await FirebaseWrite.add('kugeln', dbObject)
        }

    }

    getDBSaveObject(){
        const dbObject = JSON.parse(JSON.stringify(this))
        if ( dbObject.id ) {
            dbObject.tsLastUpdated = TimeStamp.getGMTTimestamp()
            dbObject.lastUpdatedByName = store.state.user.firstName + ' ' + store.state.user.lastName
        } else {
            dbObject.tsCreated = TimeStamp.getGMTTimestamp()
            dbObject.createdByName = store.state.user.firstName + ' ' + store.state.user.lastName
        }
        dbObject.waitingForPassPrint = true
        delete dbObject.id
        delete dbObject.local
        return dbObject
    }

    async setPrintStatus(status){
        await FirebaseWrite.update('kugeln', this.id, {waitingForPassPrint: status})
    }


}